<template>
  <div>
    <oplata-form></oplata-form>
  </div>
</template>
<script>
import OplataForm from "../Kassa Order/Update.vue";
export default {
  components: {
    OplataForm
  }
};
</script>
